import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	accountHeaderLarge: {
		width: 100,
	},
	accountHeaderSelect: {
		width: 120,
	},
	accountHeaderName: {
		width: 280,
		textAlign: 'start',
	},
	accountHeaderSmall: {
		minWidth: 60,
	},
	accountsHeader: {
		alignItems: 'center',
		color: '#767676',
		display: 'flex',
		fontSize: 11,
		justifyContent: 'space-between',
		letterSpacing: 1.1,
		padding: '30px 0 20px',
		textAlign: 'center',
		textTransform: 'uppercase',
		...CssSelectors.allDescendants(
			{
				marginBottom: 0,
			},
			'div'
		),
	},
	mrrColumn: {
		...CssSelectors.allChildren({
			color: '#767676',
			fontSize: 11,
		}),
	},
});
